<gh-default-sub-navigation [options]="options" [itemsType]="'kpis'" [recent]="recents$ | async" [suggested]="suggested$ | async" [loading]="loading$ | async"></gh-default-sub-navigation>
